export default __webpack_public_path__ + "static/media/Chatbot.0eeb9b45.gif";